  
import { 
    LOGIN_SUCCESS,
    LOGOUT_SUCCESS,
    LOGOUT_FAIL,
    GET_COMPANY, 
    GET_COMPANIES, 
    CREATE_COMPANY, 
    EDIT_COMPANY, 
    DELETE_COMPANY, 
    ARCHIVE_COMPANY, 
    GET_SEARCHABLE_COMPANIES, 
    GET_INDUSTRIES 
} from "../actions/types";

const initialState = {
    companies: [],
    company: {},
    industries: []
};

export default function (state = initialState, action) {
  switch (action.type) {
    // ensure no redux values linger between users ----
    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
    case LOGOUT_FAIL:
        return {
            ...initialState,
        }
    // ------------------------------------------------
    case GET_COMPANIES:
    case GET_SEARCHABLE_COMPANIES:
      return {
        ...state,
        companies: action.payload
      };
    case GET_COMPANY:
      return {
        ...state,
        company: action.payload
      };
    case GET_INDUSTRIES:
      return {
        ...state,
        industries: action.payload
      };
    case DELETE_COMPANY:
      return {
        ...state,
        companies: state.companies.filter((companyitem) => companyitem.id !== action.payload)
      };
    case CREATE_COMPANY:
      return {
        ...state,
        companies: [...state.company, action.payload],
        company: action.payload
      };
    case EDIT_COMPANY:
      return {
        ...state,
        companies: state.companies.filter((companyitem) => companyitem.id !== action.payload),
        companies: Object.assign(state.companies, action.payload),
        company: action.payload
      };
    default:
      return state;
  }
}

